export const LOGO_ALT = 'logo.alt';
